const serviciosData = {
  Agricultura: {
    servicios: [
      "Asesoría en técnicas de cultivo",
      "Riego automatizado",
      "Control de plagas",
    ],
    productos: [
      "Semillas certificadas",
      "Abonos orgánicos",
      "Herramientas de poda",
    ],
  },
  "Alimentos y Bebidas": {
    servicios: [
      "Producción de alimentos",
      "Distribución de bebidas",
      "Desarrollo de productos alimenticios",
    ],
    productos: [
      "Ingredientes naturales",
      "Productos orgánicos",
      "Suministros de empaque de alimentos",
    ],
  },
  Banca: {
    servicios: [
      "Préstamos personales",
      "Servicios de inversión",
      "Asesoría financiera",
    ],
    productos: [
      "Cuentas de ahorro",
      "Préstamos hipotecarios",
      "Tarjetas de crédito",
    ],
  },
  "Bienes Raíces": {
    servicios: [
      "Gestión de propiedades",
      "Valoración inmobiliaria",
      "Asesoría en inversiones inmobiliarias",
    ],
    productos: [
      "Propiedades comerciales",
      "Propiedades residenciales",
      "Terrenos",
    ],
  },
  "Bienestar Corporativo": {
    servicios: [
      "Programas de salud mental",
      "Capacitación en bienestar",
      "Actividades de bienestar físico",
    ],
    productos: [
      "Paquetes de salud y bienestar",
      "Planes de nutrición",
      "Equipamiento de fitness corporativo",
    ],
  },
  "Comercio y Comercio Electrónico (E-commerce)": {
    servicios: [
      "Consultoría en comercio electrónico",
      "Marketing digital",
      "Logística de última milla",
    ],
    productos: [
      "Plataformas de ventas en línea",
      "Soluciones de pago",
      "Sistemas de inventario",
    ],
  },
  "Consultoría en Gestión Empresarial": {
    servicios: [
      "Asesoría en finanzas",
      "Optimización de procesos",
      "Transformación digital",
    ],
    productos: [],
  },
  Construcción: {
    servicios: [
      "Construcción de viviendas",
      "Gestión de proyectos de construcción",
      "Consultoría en seguridad en obra",
    ],
    productos: [
      "Materiales de construcción",
      "Maquinaria pesada",
      "Equipos de protección personal",
    ],
  },
  "Contabilidad y Auditoría": {
    servicios: [
      "Auditoría financiera",
      "Gestión de impuestos",
      "Asesoría contable",
    ],
    productos: [
      "Software de contabilidad",
      "Herramientas de gestión de impuestos",
      "Plataformas de auditoría en línea",
    ],
  },
  "Educación Primaria y Secundaria": {
    servicios: [
      "Clases de refuerzo",
      "Orientación académica",
      "Desarrollo de currículos personalizados",
    ],
    productos: [
      "Material didáctico",
      "Libros educativos",
      "Recursos digitales de aprendizaje",
    ],
  },
  "Educación Superior": {
    servicios: [
      "Formación universitaria",
      "Cursos de especialización",
      "Orientación vocacional",
    ],
    productos: [
      "Bibliografía especializada",
      "Material de laboratorio",
      "Software educativo",
    ],
  },
  Energía: {
    servicios: [
      "Generación de energía",
      "Asesoría en eficiencia energética",
      "Instalación de paneles solares",
    ],
    productos: [
      "Paneles solares",
      "Baterías de almacenamiento",
      "Sistemas de monitoreo energético",
    ],
  },
  Hotelería: {
    servicios: [
      "Servicios de hospedaje",
      "Organización de eventos",
      "Gestión de reservas",
    ],
    productos: [
      "Artículos de higiene personal",
      "Mobiliario para habitaciones",
      "Equipamiento de cocina industrial",
    ],
  },
  "Industria Textil": {
    servicios: [
      "Diseño de prendas",
      "Fabricación textil",
      "Consultoría en sostenibilidad textil",
    ],
    productos: [
      "Tejidos ecológicos",
      "Hilos y fibras",
      "Máquinas de coser industriales",
    ],
  },
  "Logística y Distribución": {
    servicios: [
      "Gestión de inventario",
      "Transporte de mercancías",
      "Optimización de cadena de suministro",
    ],
    productos: [
      "Software de logística",
      "Equipos de carga y descarga",
      "Vehículos de transporte",
    ],
  },
  "Marketing y Publicidad Digital": {
    servicios: [
      "Campañas de redes sociales",
      "Estrategias de SEO",
      "Gestión de anuncios pagados",
    ],
    productos: [
      "Herramientas de análisis de marketing",
      "Plataformas de automatización de marketing",
      "Software de diseño gráfico",
    ],
  },
  "Materiales para Construcción": {
    servicios: [
      "Suministro de materiales",
      "Alquiler de maquinaria",
      "Asesoría en construcción",
    ],
    productos: [
      "Cemento y concreto",
      "Ladrillos y bloques",
      "Herramientas de albañilería",
    ],
  },
  "Medio Ambiente y Sostenibilidad": {
    servicios: [
      "Consultoría en sostenibilidad",
      "Gestión de residuos",
      "Educación ambiental",
    ],
    productos: [
      "Contenedores de reciclaje",
      "Equipos de energía renovable",
      "Kits de compostaje",
    ],
  },
  "Medios de Comunicación y Periodismo": {
    servicios: [
      "Producción de contenido",
      "Cobertura de eventos",
      "Consultoría de imagen",
    ],
    productos: [
      "Cámaras y equipo de grabación",
      "Software de edición de video",
      "Micrófonos profesionales",
    ],
  },
  "Medios de Radio": {
    servicios: [
      "Producción de programas",
      "Transmisión en vivo",
      "Gestión de anuncios radiales",
    ],
    productos: [
      "Micrófonos de estudio",
      "Software de transmisión",
      "Equipos de sonido",
    ],
  },
  "Medios de Televisión": {
    servicios: [
      "Producción de contenido audiovisual",
      "Publicidad en televisión",
      "Transmisión de eventos en vivo",
    ],
    productos: [
      "Cámaras de video",
      "Software de edición",
      "Iluminación profesional",
    ],
  },
  "Mantenimiento Industrial": {
    servicios: [
      "Mantenimiento preventivo",
      "Reparación de equipos",
      "Gestión de mantenimiento",
    ],
    productos: [
      "Lubricantes industriales",
      "Herramientas de mantenimiento",
      "Repuestos de maquinaria",
    ],
  },
  "Minería y Extracción": {
    servicios: [
      "Exploración geológica",
      "Extracción de minerales",
      "Tratamiento de residuos",
    ],
    productos: [
      "Equipos de perforación",
      "Herramientas de exploración",
      "Explosivos industriales",
    ],
  },
  "Pesca y Acuicultura": {
    servicios: [
      "Producción de peces",
      "Consultoría en acuicultura",
      "Control de calidad de agua",
    ],
    productos: [
      "Redes de pesca",
      "Alimento para peces",
      "Equipos de filtración",
    ],
  },
  "Recursos Humanos y Capacitación": {
    servicios: [
      "Reclutamiento de personal",
      "Evaluación de competencias",
      "Capacitación laboral",
    ],
    productos: [
      "Software de gestión de talento",
      "Sistemas de evaluación",
      "Kits de capacitación",
    ],
  },
  "Restaurantes y Servicios de Alimentos y Bebidas": {
    servicios: ["Catering", "Servicio de bar", "Organización de eventos"],
    productos: [
      "Ingredientes frescos",
      "Equipos de cocina",
      "Utensilios de bar",
    ],
  },
  "Servicios de Belleza y Estética": {
    servicios: [
      "Maquillaje profesional",
      "Cuidado capilar",
      "Tratamientos faciales",
    ],
    productos: [
      "Cosméticos",
      "Equipos de estética",
      "Productos de cuidado de la piel",
    ],
  },
  "Servicios de Limpieza": {
    servicios: [
      "Limpieza residencial",
      "Limpieza de oficinas",
      "Servicios de desinfección",
    ],
    productos: [
      "Productos de limpieza",
      "Equipos de desinfección",
      "Suministros de higiene",
    ],
  },
  "Servicios de Seguridad": {
    servicios: [
      "Seguridad física",
      "Vigilancia remota",
      "Asesoría en seguridad",
    ],
    productos: [
      "Cámaras de seguridad",
      "Sistemas de alarma",
      "Relojes de control",
    ],
  },
  "Servicios Legales": {
    servicios: [
      "Asesoría legal",
      "Representación judicial",
      "Servicios de mediación",
    ],
    productos: [],
  },
  "Tecnología de la Información": {
    servicios: [
      "Desarrollo de software",
      "Consultoría en ciberseguridad",
      "Gestión de redes",
    ],
    productos: ["Servidores", "Redes inalámbricas", "Dispositivos IoT"],
  },
  "Tecnología Financiera (Fintech)": {
    servicios: [
      "Asesoría en inversiones",
      "Desarrollo de plataformas financieras",
      "Automatización de pagos",
    ],
    productos: [
      "Software de finanzas",
      "Sistemas de pago",
      "Plataformas de inversión",
    ],
  },
  Telecomunicaciones: {
    servicios: [
      "Instalación de redes",
      "Mantenimiento de sistemas de telecomunicaciones",
      "Consultoría en comunicación",
    ],
    productos: ["Routers", "Switches", "Antenas"],
  },
  "Transporte y Movilidad": {
    servicios: [
      "Transporte de carga",
      "Transporte de personal",
      "Seguimiento GPS",
    ],
    productos: [],
  },
  "Turismo y Agencias de Viaje": {
    servicios: [
      "Planeación de viajes",
      "Organización de tours",
      "Gestión de reservas de hotel",
    ],
    productos: ["Paquetes de viaje", "Guías turísticas", "Souvenirs"],
  },
};

export default serviciosData;
